import { useState, useEffect, useMemo } from "react";
import {
	Modal,
	Box,
	Typography,
	Card,
	CardContent,
	Button,
	TextField,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	IconButton,
	Tabs,
	Tab,
	InputAdornment,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useNavigate, useParams } from "react-router-dom";
import eyeIcon from '../../assets/images/icon/eye.png';
import { getMethod } from "../../services/apiService";
import { Image } from "react-bootstrap";
import { epochToFormattedDate} from "../../helper/helper";
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import InfoHoverTooltip from "../Tooltips/InfoHover";
import CircularProgress from "@mui/material/CircularProgress";
import { IconEye } from '@tabler/icons-react';

const CustomerSitesDevicesTab = ({ data, isLoading=false }: any) => {
	let { id, companyName } = useParams();

	const navigate = useNavigate();

	const [searchText, setSearchText] = useState<string>("");

	const filteredCustomers = useMemo(() => {
		if (!Array.isArray(data)) return [];
		if (!searchText || searchText === "") return data;
		return data.filter((dataItem: any) =>
			dataItem?.vSite?.name?.toLowerCase().includes(searchText.toLowerCase())
		);
	}, [data, searchText]);


	const [siteData, setSiteData] = useState({ index: null, customer: [] })
	const [siteOrderList, setSiteOrderList] = useState<any>([])

	const fetchSiteOrderData = async (siteId: any) => {
		getMethod(`customer/order/siteid/details/${siteId}`).then((res) => {
			if (res.status === 200) {
				setSiteOrderList(res?.data?.result)
			}
		})
	}

	const handleSite = (e: any, index: any, customer: any) => {
		const data = siteData?.index === index ? { index: null, customer: [] } : { index, customer }
		setSiteOrderList([])

		console.log("siteOrderList: ", siteOrderList)

		setSiteData(data)
		if (data?.customer?.vSite?.siteId) {
			fetchSiteOrderData(data?.customer?.vSite?.siteId)
		}
	}

	const handleNavigate = (e: any, license: any, index: any) => {
		localStorage.setItem('siteId', license?.vSite?.siteId)
		navigate(`/customer/view/${companyName}/${license?.vSite?.name}/${id}`);
	}

	return (
		<Box sx={{ backgroundColor: "#03171F", color: "#ffffff", minHeight: "100vh" }}>
			{/* Summary Section */}


			<Grid container mb={5}>
				<Grid size={{ xs: 12, md: 6 }}>
					<TextField
						fullWidth
						placeholder="Search by customer name or address"
						variant="outlined"
						className="searchBox"
						onChange={(e) => setSearchText(e.target.value)}
						sx={{
							backgroundColor: "#1e222b",
							input: { color: "#ffffff" },
							borderRadius: '30px',
							border: '1px solid #5A5F60',
							padding: '0 5px !important',
							height: '41px',
							fontWeight: 'normal',
						}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon style={{ color: "#ffffff", cursor: "pointer" }} />
								</InputAdornment>
							),
						}}
					/>
				</Grid>
			</Grid>

			{/* Table Section */}
			<Table sx={{ backgroundColor: "#03171f", border: '1px solid #313838' }}>
				<TableHead sx={{ border: '1px solid #313838' }}>
					<TableRow>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }}>No.</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }}>Site / Device</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }} style={{width: "325px"}}>License Item (SKU)</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }} style={{width: "85px"}}>Quantity</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }} style={{width: "170px"}}>Issue Date</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }} style={{width: "170px"}}>Expiry Date</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }} style={{width: "365px"}}>License Key</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838'}}></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					 {isLoading ? (
				<TableRow>
				<TableCell colSpan={8} sx={{ textAlign: 'center', borderColor: '#313838', padding: '32px' }}>
					<CircularProgress size={32} sx={{ color: '#1976d2' }} />
				</TableCell>
				</TableRow>
			) : (
				<>
					{filteredCustomers?.map((license: any, index: any) => (
						<>
							{/* Main Row for the License */}
							<TableRow key={license.id} onClick={(e) => handleSite(e, index, license)}>
								<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838' }}>{index + 1}</TableCell>

								<TableCell sx={{ color: '#B4B7B8', borderBottom: 'none', padding: '16px' }}>
									{license?.vSite?.name}
								</TableCell>
								<TableCell sx={{ color: '#B4B7B8', borderBottom: 'none', padding: '16px', display: 'flex', alignItems: "center" }}>
									All Licenses
									<ExpandMoreIcon sx={{ cursor: 'pointer', color: '#B4B7B8', fontSize: '25px', marginLeft: '10px' }} />

								</TableCell>
								<TableCell sx={{ color: '#B4B7B8', borderBottom: 'none', padding: '16px' }}>

								</TableCell>
								<TableCell colSpan={3} sx={{ borderBottom: 'none', padding: '16px' }}>

								</TableCell>
								<TableCell sx={{ color: '#B4B7B8', borderBottom: 'none', padding: '16px' }}>
									<p onClick={(e) => { e.stopPropagation(); handleNavigate(e, license, index) }}>
										{/* <Image src={eyeIcon} style={{ cursor: "pointer", }} /> */}
										<IconEye stroke={1.8} size={16} color="#B4B7B8" 
                                               style={{ cursor: "pointer" }}  
                                               />
									</p>
								</TableCell>
							</TableRow>

							{siteData?.index === index ? (
								siteOrderList.length > 0 ? (
									siteOrderList.map((item: any, keyIndex: any) => (
										<TableRow key={keyIndex} sx={{ background: '#192529' }} >
											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>{keyIndex + 1}</TableCell>

											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>
												{item?.vSite?.name}
											</TableCell>

											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}> {item?.siteOrder?.data[0].featureName}</TableCell>

											<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", margin: '0' }}>
												<InfoHoverTooltip title={"Used / Total"}
													arrowDirection="top">
													<Typography component="span">
														{item?.countData?.assigned} / {item?.countData?.total}
													</Typography>
												</InfoHoverTooltip>
											</TableCell>

											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>{epochToFormattedDate(item?.siteOrder?.data[0].createdAt)}</TableCell>
											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>{epochToFormattedDate(item?.siteOrder?.data[0].expiry)}</TableCell>
											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>{item?.siteOrder?.data[0].licenseKey}</TableCell>
											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0' }}>&nbsp;</TableCell>
										</TableRow>
									))
								) : (
									<TableRow sx={{ background: '#192529' }}>
										<TableCell
											sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }}
											colSpan={9}
										>
											No Data
										</TableCell>
									</TableRow>
								)
							) : null}

						</>

					))}
					{!filteredCustomers?.length && !isLoading &&
					<TableRow>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', textAlign: 'center' }} colSpan={8}>
							No Data
						</TableCell>
					</TableRow>
				}
					   </>
                  )}
				</TableBody>
			</Table>

		</Box>
	);
};

export default CustomerSitesDevicesTab;
